import { useMatch } from 'react-router-dom'

const useItemId = (baseUrl: string) => {
  const match = useMatch(`/${baseUrl}/:id`)
  return (match?.params as any)?.id
}

export default useItemId
